<template>
  <layout-scroll-content>
    <div class="row">
      <div class="col-xl-8 col-12 order-2 order-xl-1">
        <!-- FORM OF RFQ -->
        <form-rfq
          :disabled="!isAllowToEditRFQs"
          ref="FormRFQ"
          :data="data"
          :dataID="data.id"
          :model="formModel"
          @updateModelItem="handlerUpdateModelItem"
          @updateViewData="handlerUpdateViewDataRFQ"
          @change="(formData) => $emit('command', 'update-form-data', formData)"
        ></form-rfq>
        <!-- GRID OF RFQ1 -->
        <add-to-rfq-3
          :disabled="!isAllowToEditRFQs"
          :moduleName="moduleName"
          :data="data"
          :isValid="true"
          :eventID="eventID"
          :showButton="false"
        ></add-to-rfq-3>
        <!-- LIST OF RFQ3 -->
        <list-rfq-3
          :disabled="!isAllowToEditRFQs"
          withClone
          withDownload
          :moduleName="moduleName"
          :data="data"
          :isValid="true"
          :eventID="eventID"
          :showButton="false"
        />
      </div>
      <!-- INFO -->
      <div class="col-xl-4 col-12 order-1 order-xl-2 vb-xl">
        <info-section-rfq :data="fullDataRFQ"></info-section-rfq >
        <info-section-parts
          :listRFQ1="listRFQ1"
          :mapListRFQ3="mapListRFQ3"
          :isDisabledAddToQuote="!isAllowToEditRFQs"
          :isSendQuote="false"
          @onAddToRFQ3="openDialogAddToRFQ3"
        />
        <info-section-quotes
          :data="listRFQ3"
          :fieldList="fieldListInfoRFQ3"
        ></info-section-quotes>
        <info-data-rfq :data="fullDataRFQ" :model="modelInfoPo">
          <template v-slot:header>
            <span class="title">{{L10n('po')}}: </span> <span>{{fullDataRFQ.po}}</span>
          </template>
        </info-data-rfq>
      </div>
      <!-- DIALOG -->
      <dialog-add-to-rfq3 :isLoading="isLoading" ref="dialog-add-to-rfq3" />
      <dialog-send-order-ackn ref="dialog-send-order-ackn" :rfqID="data.id"/>
    </div>
    <template v-slot:footer>
      <!-- CONTROLS -->
      <form-controls
        class="form-footer"
        :isSave="hasCreateNew && isAllowToEditRFQs"
        @command="controllerCommand">
        <div class="control btn-mobile-full">
          <logo-button @click="handleSendOrderAck" :getPdfContent="getPdfContentPoAcknowledgment">
            {{L10n('email-po-acknowledgment')}}
          </logo-button>
        </div>
      </form-controls>
    </template>
  </layout-scroll-content>
</template>

<script>
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import { ModelInfoPOShort } from '@/services/RFQs'
import { api } from '@/services/api'
import { ServicePdf } from '@/services/pdf-generators'

export default {
  name: 'TabRFQ',
  mixins: [FormWrapperAutoSave],
  components: {
    'logo-button': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/LogoButton'),
    'layout-scroll-content': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/EditorPage/ScrollContent.vue'),
    'form-rfq': () => import(/* webpackChunkName: 'CustomerPoOpen' */ './FormRFQ.vue'),
    'add-to-rfq-3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQAddToRFQ3/Index.vue'),
    'list-rfq-3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQListRFQ3/Index.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'info-section-quotes': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoSectionQuotes'),
    'info-data-rfq': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoDataRFQ'),
    'info-section-rfq': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoSectionRFQ'),
    'info-section-parts': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoSectionParts'),
    'dialog-add-to-rfq3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQDialogAddToRFQ3/Index'),
    'dialog-send-order-ackn': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/DialogSendOrderAckn')
  },
  props: {
    eventID: { type: String, required: true },
    moduleName: { type: String, required: true },
    hasCreateNew: { type: Boolean },
    data: { type: Object },
    formData: { type: Object },
    fullDataRFQ: { type: Object }
  },
  data () {
    return {
      isLoading: false,
      fieldListInfoRFQ3: [
        { title: this.L10n('chosen'), fieldName: 'chosen' },
        { title: this.L10n('part-number'), fieldName: 'partNumber' },
        { title: this.L10n('qty'), fieldName: 'qty' },
        { title: this.L10n('price'), fieldName: 'price' },
        { title: this.L10n('partSN'), fieldName: 'partSN' },
        { title: this.L10n('condition'), fieldName: 'conditionID' }
      ]
    }
  },
  computed: {
    isAllowToEditRFQs () {
      return this.permission(this.$store.getters.get('permissions'), 'isAllowToEditRFQs')
    },
    isAvailableToSave () {
      return this.isAllowToEditRFQs
    },
    mapListRFQ3 () {
      return this.$store.getters[`${this.moduleName}/mapListRFQ3`]
    },
    listRFQ1 () {
      return this.$store.state[this.moduleName].listRFQ1
    },
    listRFQ3 () {
      return this.$store.state[this.moduleName].listRFQ3
    }
  },
  methods: {
    modelInfoPo () {
      return ModelInfoPOShort()
    },
    formModel () {
      return {
        id: null,
        rfqid: '',
        customerCompanyID: null,
        customerCompanyDetailID: null,
        customerContactID: null,
        requestedDate: null,
        rfqTypeID: null,
        baxEmployeeID: this.$store.getters.get('currentUser').employeeID,
        po: '',
        poDate: null,
        pOisOpen: true,
        step1: false,
        step3: false,

        shipToCompanyID: null,
        shipToContactID: null,
        shipToCompanyDetailID: null,
        customerForwarderID: null,
        priorityID: null,
        orderRatingScoreID: null,
        paymentTermID: null,
        observation: ''
      }
    },
    // Handler of command from main editor
    controllerCommand (command) {
      switch (command) {
        case 'save':
          this.save()
          break
        default:
          this.setCommand(command)
          break
      }
    },
    // Send command to main editor
    setCommand (command) {
      this.$emit('command', command)
    },
    save () {
      this.$refs.FormRFQ.validate()
        .then(() => {
          let data = this.$refs['FormRFQ'].getData()
          let url = `RFQs/Patch/${data.id}`
          return api
            .patch(`${url}`, data)
            .then((response) => {
              this.requestSuccessHandler()
            })
            .catch(error => {
              this.requestErrorHandler(error)
            })
        })
    },
    getFormData () {
      return this.$refs.FormRFQ.getData()
    },
    handlerUpdateViewDataRFQ (value) {
      this.$store
        .commit(`${this.moduleName}/MERGE`, { key: 'dataViewRFQ', value })
    },
    handleSendOrderAck (logoType) {
      this.$refs['dialog-send-order-ackn']
        .show({ logoType })
    },
    openDialogAddToRFQ3 (dataRFQ1) {
      let dialog = this.$refs['dialog-add-to-rfq3']
      dialog.open(dataRFQ1, (data) => {
        this.isLoading = true
        this.handlerAddRFQ1ToRFQ3(data)
          .then(() => {
            this.isLoading = false
            dialog.close()
            this.requestSuccessHandler()
          })
          .catch((err) => {
            this.isLoading = false
            this.requestErrorHandler(err)
          })
      })
    },
    handlerAddRFQ1ToRFQ3 (data) {
      return this.$store.dispatch(`${this.moduleName}/addRFQ1ToRFQ3`, data)
        .then(() => {
          this.$bus.$emit(`refresh-data-${this.eventID}`)
        })
    },
    getPdfContentPoAcknowledgment () {
      return ServicePdf.generateOrderAcknowledgmentContent({ id: this.data.id, translate: this.L10n })
    }
  }
}
</script>
